import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  connect() {
    this.disableTurbolinksOnLinks()
    this.observeChanges()
  }

  disconnect() {
    if (this.observer) {
      this.observer.disconnect()
    }
  }

  disableTurbolinksOnLinks() {
    const links = this.element.querySelectorAll('a')
    links.forEach(link => {
      link.setAttribute('data-turbo', 'false')
    })
  }

  observeChanges() {
    this.observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) {
            // Check if the added node is a link
            if (node.tagName === 'A') {
              node.setAttribute('data-turbo', 'false')
            }
            // Check for links within the added node
            const links = node.querySelectorAll?.('a')
            if (links) {
              links.forEach(link => link.setAttribute('data-turbo', 'false'))
            }
          }
        })
      })
    })

    this.observer.observe(this.element, {
      childList: true,
      subtree: true
    })
  }
}
